import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postWager = (params) => {
    return axios.post(`${backendHost}/api/admin/wager/cashier`, params);
};

export {
    postWager
}